import { cookies } from '../_helpers'

export const placeServices = {
    getPlaces,
    getAllPlaces,
}

function getPlaces(placeSlug) {
    const requestOptions = {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'X-CSRFToken': cookies.getCookie('csrftoken'),
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    }

    return fetch(`/api/places/?category=${placeSlug}`, requestOptions)
        .then(res => res.json())
        .then(data => data)
}

function getAllPlaces() {
    const requestOptions = {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'X-CSRFToken': cookies.getCookie('csrftoken'),
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    }

    return fetch(`/api/places/`, requestOptions)
        .then(res => res.json())
        .then(data => data)
}
